import KintoLogo from '@assets/logos/kinto.svg'
import LexusLogo from '@assets/logos/lexus.svg'
import LexusKintoLogo from '@assets/logos/lexus-kinto.svg'
import ToyotaLogo from '@assets/logos/toyota.svg'
import ToyotaKintoLogo from '@assets/logos/toyota-kinto.svg'
import ToyotaLexusLogo from '@assets/logos/toyota-lexus.svg'
import { useBrand } from '@contexts/useBrand'
import type { SVGProps } from 'react'

type Props = SVGProps<any> & {
  logoType?: string
}

const Logo = ({ logoType, ...rest }: Props) => {
  const brand = useBrand()

  const type = logoType || brand
  switch (type) {
    case 'kinto':
      return <KintoLogo {...rest} />
    case 'lexus':
      return <LexusLogo {...rest} />
    case 'lexus-kinto':
      return <LexusKintoLogo {...rest} />
    case 'toyota-kinto':
      return <ToyotaKintoLogo {...rest} />
    case 'toyota-lexus':
      return <ToyotaLexusLogo {...rest} />
    case 'toyota':
    default:
      return <ToyotaLogo {...rest} />
  }
}

export default Logo
